import * as React from "react"
import Svg, { SvgProps, G, Path } from "react-native-svg"
import colors from '../../helpers/Colors';

const ImdbIcon = (props: SvgProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={100}
    viewBox="0 0 300.000000 150.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <G
      transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)"
      fill={colors.slate}
    >
      <Path d="M278 1490 c-103 -18 -197 -93 -247 -199 l-26 -56 0 -485 0 -485 29 -63 c41 -88 116 -155 204 -182 66 -20 86 -20 1287 -18 l1220 3 47 22 c66 30 143 105 175 172 l28 56 0 490 0 490 -29 62 c-34 75 -95 134 -174 171 l-57 27 -1205 1 c-663 1 -1226 -2 -1252 -6z m392 -715 l0 -415 -100 0 -100 0 0 415 0 415 100 0 100 0 0 -415z m363 393 c3 -13 17 -96 33 -185 15 -90 29 -162 30 -160 2 2 13 85 25 185 l22 182 139 0 138 0 0 -415 0 -415 -85 0 -85 0 -1 218 -1 217 -23 -120 c-12 -66 -31 -164 -40 -217 l-17 -98 -64 0 c-51 0 -64 3 -68 18 -3 9 -19 100 -36 202 -17 102 -32 190 -34 195 -3 6 -5 -86 -5 -202 l-1 -213 -95 0 -95 0 0 415 0 415 129 0 c125 0 129 -1 134 -22z m901 -3 c22 -11 49 -33 60 -48 20 -27 21 -43 24 -325 3 -344 2 -348 -84 -392 -46 -24 -59 -25 -231 -28 l-183 -3 0 411 0 412 188 -4 c163 -3 192 -6 226 -23z m356 -65 l0 -90 43 23 c80 42 170 23 204 -44 9 -17 13 -99 13 -292 l0 -269 -29 -29 c-26 -26 -37 -29 -89 -29 -33 0 -79 7 -102 15 -56 20 -67 19 -75 -5 -6 -18 -15 -20 -91 -20 l-84 0 0 415 0 415 105 0 105 0 0 -90z" />
      <Path d="M1720 785 l0 -275 28 0 c51 0 52 5 52 277 0 239 -1 253 -19 263 -11 5 -29 10 -40 10 -21 0 -21 -4 -21 -275z" />
      <Path d="M2305 948 c-3 -7 -4 -117 -3 -243 3 -197 5 -230 18 -230 13 0 15 33 15 239 0 183 -3 240 -12 243 -7 3 -15 -1 -18 -9z" />
    </G>
  </Svg>
)

export default ImdbIcon;
